/*!

=========================================================
* - v1.4.0
=========================================================

* Product Page: 
* Copyright 2020 Ahmed Abosaif
* Licensed under MIT Ahmed Abosaif

* Coded by Ahmed Abosaif

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// react plugin used to create charts
import { Line } from "react-chartjs-2";
import {Link} from 'react-router-dom';



import {PieChart ,ColChart } from "../components/Chart/index"


// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
  Button

} from "reactstrap";

// core components
import PanelHeader from "components/PanelHeader/PanelHeader.js";

import dashboardPanelChart from "variables/charts.js";


class Dashboard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      redirect: null,
      userReady: true,
      currentUser: { username: "" },
      chartdata:[],
      loading:true,

      allcount:0,
      notescount:[
        {
            "label": "test.agent1",
            "y": 29,
            "x": 0
        },
        {
            "label": "test.agent2",
            "y": 44,
            "x": 1
        },
        {
            "label": "test.agent3",
            "y": 17,
            "x": 2
        },
        {
            "label": "test.agent4",
            "y": 56,
            "x": 3
        },
        {
            "label": "test.agent5",
            "y": 6,
            "x": 4
        },
        {
            "label": "test.agent6",
            "y": 31,
            "x": 5
        },
        {
            "label": "test.agent7",
            "y": 23,
            "x": 6
        },
        {
            "label": "test.agent8",
            "y": 8,
            "x": 7
        },
        {
            "label": "test.agent9",
            "y": 4,
            "x": 8
        }
    ],
      countallassignee:[
        {
            "label": "test.agent14",
            "count": 50,
            "y": "21.5"
        },
        {
            "label": "test.agent13",
            "count": 18,
            "y": "7.7"
        },
        {
            "label": "test.agent12",
            "count": 33,
            "y": "14.2"
        },
        {
            "label": "test.agent11",
            "count": 31,
            "y": "13.3"
        },
        {
            "label": "test.agent10",
            "count": 24,
            "y": "10.3"
        },
        {
            "label": "test.agent9",
            "count": 18,
            "y": "7.7"
        },
        {
            "label": "test.agent8",
            "count": 8,
            "y": "3.4"
        },
        {
            "label": "test.agent7",
            "count": 3,
            "y": "1.3"
        },
        {
            "label": "test.agent6",
            "count": 6,
            "y": "2.6"
        },
        {
            "label": "test.agent5",
            "count": 13,
            "y": "5.6"
        },
        {
            "label": "test.agent4",
            "count": 6,
            "y": "2.6"
        },
        {
            "label": "test.agent3",
            "count": 19,
            "y": "8.2"
        },
        {
            "label": "test.agent2",
            "count": 1,
            "y": "0.4"
        },
        {
            "label": "test.agent1",
            "count": 2,
            "y": "0.9"
        },
        {
            "label": "test.agent16",
            "count": 1,
            "y": "0.4"
        }
    ],
      countallsite:[
        {
            "label": "Site5",
            "count": 53,
            "y": "22.7"
        },
        {
            "label": "Site2",
            "count": 75,
            "y": "32.2"
        },
        {
            "label": "Site1",
            "count": 54,
            "y": "23.2"
        },
        {
            "label": "Site3",
            "count": 32,
            "y": "13.7"
        },
        {
            "label": "Site4",
            "count": 18,
            "y": "7.7"
        },
        {
            "label": "Outside",
            "count": 1,
            "y": "0.4"
        }
    ],
      countallstates:[
        {
            "label": "Closed",
            "count": 173
        },
        {
            "label": "Open",
            "count": 12
        },
        {
            "label": "Completed",
            "count": 45
        },
        {
            "label": "Waiting For User",
            "count": 2
        },
        {
            "label": "Pending",
            "count": 1
        }
    ], //done
      countslares:[
        {
            "label": "Achieved",
            "count": 160
        },
        {
            "label": "Violated",
            "count": 13
        }
    ]

    };
          
          


      
      
    




  
  




  }








  








      

      componentDidMount() {



        this.interval = setInterval(() => {
          
          


          
        
        
        }, 60000);
      }
      
      componentWillUnmount(){
      
        clearInterval(this.interval);
      }
      














  


  render() {


    let cdata = 
    [
      {
          "category": "Email",
          "count": 16
      },
      {
          "category": "Health Check",
          "count": 18
      },
      {
          "category": "Office",
          "count": 9
      },
      {
          "category": "Computer",
          "count": 17
      },
      {
          "category": "Mail Services",
          "count": 1
      },
      {
          "category": "Network",
          "count": 9
      },
      {
          "category": "Asset Management",
          "count": 7
      },
      {
          "category": "iP Phone",
          "count": 4
      },
      {
          "category": "Printer",
          "count": 15
      },
      {
          "category": "Other",
          "count": 5
      },
      {
          "category": "Configuration Backup",
          "count": 16
      },
      {
          "category": "Backup Mangement",
          "count": 2
      },
      {
          "category": "Active Directory",
          "count": 3
      },
      {
          "category": "Applications",
          "count": 10
      },
      {
          "category": "File",
          "count": 3
      },
      {
          "category": "iP-Cam",
          "count": 1
      },
      {
          "category": "iP-Phone",
          "count": 1
      },
      {
          "category": "SAP Reservation",
          "count": 2
      }
  ];


  /*  if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />
    }

    const { currentUser } = this.state;*/



let lables = [];
let chartfinalData = [];

cdata.map(cat => {lables.push(cat.category);chartfinalData.push(cat.count)})



let GetMainMethod = new dashboardPanelChart(lables,chartfinalData );
let Chart = GetMainMethod.chartdatamethod();


let reportingCards = this.state.countallstates.map(card =>

  <Col xs={8} sm={6} md={2} lg={2} key={card.label} style={{ marginLeft:'0px'}}>


  <Card  style={{ boxShadow: '  0 0 5px gray,  0 0 5px gray,  0 0 5px gray' , borderRadius:"5px"}}>
    <CardHeader style={{backgroundColor:'white'}}>
     <strong  style={{color:"#343a40" , fontSize:15}}>{card.label}</strong> 


    </CardHeader>



    <CardBody style={{backgroundColor:"rgba(250, 250, 250,0.1)"}}>
    <strong  style={{fontSize:30 , color:'rgb(140, 180, 90)'}}> {card.count}</strong>

    <Link to={`/admin/tickets/${card.label}`} ><br/>
    <Button style={{backgroundColor:'rgb(130, 190, 80)'}}  >View All</Button>
    </Link>
    </CardBody>




  </Card>

</Col>

);


let slaCards = this.state.countslares.map(card =>

  <Col xs={8} sm={6} md={2} lg={2} key={card.label} style={{ marginLeft:'0px'}}>

  <Card  style={{ boxShadow: '  0 0 5px gray,  0 0 5px gray,  0 0 5px gray' , borderRadius:"5px" }}>
    <CardHeader style={{backgroundColor:'white'}}>
    <strong  style={{color:"#343a40" , fontSize:15}}>{card.label}</strong>

    </CardHeader>



    <CardBody style={{backgroundColor:"rgba(250, 250, 250,0.1)"}}>
    <strong  style={{fontSize:30 , color:'rgb(140, 180, 90)'}}> {card.count}</strong>

    </CardBody>




  </Card>
</Col>

);






    return (
      
      <>
            <div>
        {(this.state.userReady) ?
        <div>
        <PanelHeader

          size={window.innerWidth > 991 ? 'lg' : 'md'}
          padding={40}
          content={
            <Line

              data={Chart.data}
              options={Chart.options}
              
            />

          }
          
        />

        <div className="content">










        





<Row>
<Col md={12}>
        
          <Card className="card-chart"style={{ boxShadow: '  0 0 5px gray,  0 0 20px gray,  0 0 5px gray' , borderRadius:"10px"}}>
    <CardHeader style={{color:"#343a40" , fontSize:25 , textAlign:"center"}}>

    <CardTitle tag="strong" ># Tickets Count</CardTitle>
<hr/>
    </CardHeader>




    <CardBody>
    <Row className="justify-content-center align-items-center"  style={{textAlign: 'center'}}>

    {reportingCards}

    </Row>

    </CardBody>




  </Card>
  </Col>
  </Row>



  <Row>
<Col md={12}>
        
          <Card className="card-chart"style={{ boxShadow: '  0 0 5px gray,  0 0 20px gray,  0 0 5px gray' , borderRadius:"10px"}}>
    <CardHeader style={{color:"#343a40" , fontSize:25 , textAlign:"center"}}>

    <CardTitle tag="strong" ># Response SLA</CardTitle>
<hr/>
    </CardHeader>




    <CardBody>
    <Row className="justify-content-center align-items-center"  style={{textAlign: 'center'}}>


    {slaCards}
    </Row>

    </CardBody>




  </Card>
  </Col>
  </Row>



  <br/>


<Row className="justify-content-center align-items-center"  style={{textAlign: 'center'}}>
<Col xs={12} sm={12}  md={7} lg={7}>

  <Card className="card-chart"style={{ boxShadow: '  0 0 5px gray,  0 0 20px gray,  0 0 5px gray' , borderRadius:"10px"}}>
    <CardHeader style={{color:"#343a40" , fontSize:25 , textAlign:"center"}}>
    <hr/>

    <CardTitle tag="strong" ><i className="now-ui-icons users_circle-08" /> Tickets Per Assignee</CardTitle>
<hr/>
    </CardHeader>

    <CardBody>

<PieChart theme={"light1"}  data={this.state.countallassignee} />


    </CardBody>

  </Card>

</Col>




<Col xs={12} sm={12}  md={5} lg={5}>

  <Card className="card-chart"style={{ boxShadow: '  0 0 5px gray,  0 0 20px gray,  0 0 5px gray' , borderRadius:"10px"}}>
    <CardHeader style={{color:"#343a40" , fontSize:25 , textAlign:"center"}}>
    <hr/>

    <CardTitle tag="strong" ><i className="now-ui-icons location_pin" /> Tickets Per Site</CardTitle>
<hr/>
    </CardHeader>

    <CardBody>

<PieChart theme={"light1"}   data={this.state.countallsite} />

    </CardBody>

  </Card>

</Col>



</Row>




<br/>







  <Card className="card-chart"style={{ boxShadow: '  0 0 5px gray,  0 0 20px gray,  0 0 5px gray' , borderRadius:"10px"}}>
    <CardHeader style={{color:"#343a40" , fontSize:25 , textAlign:"center"}}>
    <hr/>

    <CardTitle tag="strong" ><i className="now-ui-icons business_chart-bar-32" /> Agent Activity</CardTitle>
<hr/>
    </CardHeader>

    <CardBody>
    <Row className="justify-content-center align-items-center"  style={{textAlign: 'center'}}>
    <Col xs={12} sm={12}  md={12} lg={12}>

<ColChart data={this.state.notescount} />
</Col>
    </Row>

    </CardBody>

  </Card>






        </div>



      </div>: null}
      </div>

      </>
    );
  }
}

export default Dashboard;
